import {Button} from 'react-bootstrap'
import {KTSVG} from '../../../_metronic/helpers'
import * as React from 'react'
import {useTranslation} from 'react-i18next'

interface AddOrderButtonProps {
  onClick?: () => void
}

export const AddOrderButton: React.FC<AddOrderButtonProps> = (props) => {
  const {t} = useTranslation()

  return (
    <div
      className='card-toolbar '
      data-bs-toggle='tooltip'
      data-bs-placement='top'
      data-bs-trigger='hover'
      title={t('order-tambahOrder')}
    >
      <button className='btn btn-primary d-flex align-items-center h-100' onClick={props.onClick}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
        <span className='d-block fs-6'>{t('order-tambahOrder')}</span>
      </button>
    </div>
  )
}
